// LoginMerchant.jsx
// ------------------------------------------------------------
// Page de connexion marchand (connectée au backend)
// ------------------------------------------------------------

import React, { useState } from "react";
import api from "./axiosConfig";
import { setMerchantAuth } from "./auth";
import { useNavigate } from "react-router-dom";

export default function LoginMerchant() {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const [errorMsg, setErrorMsg] = useState("");
  const navigate = useNavigate();

  async function handleLogin(e) {
    e.preventDefault();
    setLoading(true);
    setErrorMsg("");

    try {
      const res = await api.post("/merchant/login", {
        email,
        password,
      });

      // Sauvegarde dans localStorage
      setMerchantAuth(res.data.token, res.data.merchant);

      // Redirection dashboard
      navigate("/merchant/dashboard");
    } catch (err) {
      console.error("Erreur login merchant :", err);
      setErrorMsg(err.response?.data?.error || "Erreur lors de la connexion");
    } finally {
      setLoading(false);
    }
  }

  return (
    <div className="flex items-center justify-center min-h-screen p-4 bg-gray-50">
      <div className="w-full max-w-md p-8 bg-white shadow-xl rounded-2xl">
        <h2 className="mb-6 text-2xl font-bold text-center">
          Connexion Marchand
        </h2>

        {errorMsg && (
          <p className="mb-4 text-center text-red-500">{errorMsg}</p>
        )}

        <form onSubmit={handleLogin} className="space-y-5">
          <div>
            <label className="block mb-1 font-medium">Email</label>
            <input
              type="email"
              className="w-full p-3 border rounded-lg"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              required
              autoComplete="email"
            />
          </div>

          <div>
            <label className="block mb-1 font-medium">Mot de passe</label>
            <input
              type="password"
              className="w-full p-3 border rounded-lg"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              required
              autoComplete="current-password"
            />
          </div>

          <button
            type="submit"
            disabled={loading}
            className="w-full py-3 font-semibold text-white transition bg-green-600 rounded-lg hover:bg-green-700"
          >
            {loading ? "Connexion…" : "Se connecter"}
          </button>
        </form>
      </div>
    </div>
  );
}